










































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class P0019 extends Vue {}
